import { Link } from 'react-router';
import { Dialog } from '../../../components/dialog-portal/dialog.tsx';
import { formatDuration } from '../../../utils/fieldFormats.ts';
import { MachineStatusRow } from './autoTaskRow.ts';

export function DisconnectedMachinesDialog({ tasks, onClose }: { tasks: MachineStatusRow[]; onClose: () => void }) {
    return (
        <Dialog title='Disconnected Machines' onClose={onClose}>
            <div style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', padding: '8px 10px 12px' }}>
                <p style={{ marginTop: 0, marginBottom: 12 }}>
                    Currently disconnected machines: <strong>{tasks.length}</strong>
                </p>

                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0 }}>
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'left', padding: '6px 8px' }}>Coordinates</th>
                            <th style={{ textAlign: 'left', padding: '6px 8px' }}>Equipment</th>
                            <th style={{ textAlign: 'left', padding: '6px 8px' }}>Disconnected time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map((task, index) => {
                            return (
                                <tr key={task.equipment + '_' + index}>
                                    <td className='tasks--large-text' style={{ padding: '4px 8px' }}>
                                        {task.coordinates}
                                    </td>
                                    <td className='textAlignLeft' style={{ padding: '4px 8px' }}>
                                        <Link className='link-button--non-intrusive' to={`/machine-log#equipment=${task.equipment}`}>
                                            {task.name}
                                        </Link>
                                    </td>
                                    <td className='tasks--large-text' style={{ padding: '4px 8px', color: 'red' }}>
                                        {formatDuration(task.duration, true, false)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </Dialog>
    );
}
